<div class="countries-container">
  <div class="categories-list">
    <p *ngFor="let category of categoriesList">
      <!--      {{ 'view_translations.' + category | translate }}-->
      {{ 'categories.' + category?.id | translate }}
    </p>
  </div>
</div>
